/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectService {
  displayConnect=false;
  connectData:any;
  connect_item_image_url='';
  connect_item_name='';
  connectForm!:FormGroup;
  userTypes: any;
  productPageSubject:any;
  constructor(private _as:AppService) { }


  getConnectData(data?:any){
    this.connectData=data;
    this.displayConnect=true;
    this.getUserTypes();
  }

  setFormValues(){
    this.connectForm.get('name')?.setValue(this._as.user_info?.userProfile?.username)
      this.connectForm.get('last_name')?.setValue(this._as.user_info?.userProfile?.last_name)
      this.connectForm.get('email')?.setValue(this._as.user_info?.userProfile?.email)
      this.connectForm.get('mobile')?.setValue(this._as.user_info?.userProfile?.mobile)
      this.getUserTypes();
  }

  getUserTypes(){
    const url = this._as.api_base_url + 'renovarz/user-type/';
    this._as.getRequest(url,false).subscribe((res:any)=>{
      this.userTypes=res.user_type_list
      if(this._as.isUserLoggedIn){
        const userType = this.userTypes.find((user:any) => {
          return user.name === this._as.user_info?.userProfile?.customer_type;
      });
        this.connectForm.get('user_type')?.setValue(userType)
      }
    })
  }
}
